import { Component } from '@angular/core';

@Component({
    selector: 'typography-cmp',
    moduleId: module.id,
    templateUrl: 'typography.component.html'
})

export class TypographyComponent{}



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/typography/typography.component.ts